import React from 'react';
import BannerSlider from '../components/banner/BannerSlider';

const BespokeSuiting = () => {
  const heroSlides = [
    { label: 'Cream Ivory Suit', src: '/images/suit-cream-ivory.webp' },
    { label: 'Teal Beaded', src: '/images/suit-teal-beaded.webp' },
    { label: 'Burgundy Double Breasted', src: '/images/suit-burgundy-doublebreasted.webp' },
    { label: 'Navy Scarf Blazer', src: '/images/suit-navy-scarf.webp' },
    { label: 'Black Embroidered', src: '/images/suit-black-embroidered.webp' },
  ];

  const offerings = [
    { title: 'Classic Two-Piece', detail: 'Structured silhouettes for boardroom and formal occasions.', img: '/images/suit-cream-ivory.webp' },
    { title: 'Three-Piece Signature', detail: 'Waistcoat-led composition with heritage tailoring precision.', img: '/images/three-piece.webp' },
    { title: 'Tuxedo Program', detail: 'Black-tie construction with contemporary proportion control.', img: '/images/tuxedo-program.webp' },
    // { title: 'Ethnic', detail: "Timeless men's ethnic wear crafted with rich fabrics and modern elegance, perfect for every festive and cultural occasion.", img: '/images/ethnic.webp' },
    { title: 'Seasonal Edit', detail: 'Fabric-forward suits optimized for climate and movement.', img: '/images/3-piece.webp' },
    { title: 'Double-Breasted Suit', detail: 'Formal jacket style with overlapping front panels and two rows of buttons, creating a sharp, structured, and elegant look.', img: '/images/travel.webp' },
    { title: 'BESPOKE-.Precision Fit. Timeless Elegance.', detail: 'The Art of Personal Tailoring . Tailored Exclusively, Worn Exceptionally', img: '/images/suit-scarlet-shawl.webp' },
  ];

  return (
    <>
      {/* Mobile banner */}
      <div className="block lg:hidden relative w-full overflow-hidden">
        <img src="/images/mans-tailoring-banner.webp" alt="Bespoke Suiting" className="w-full h-auto object-contain" />
      </div>
      <div className="block lg:hidden px-6 py-6 bg-background-light dark:bg-background-dark">
        <span className="text-[10px] uppercase tracking-[0.5em] text-primary mb-4 block">Bespoke Craft</span>
        <h1 className="font-display text-4xl leading-[0.95] mb-4 dark:text-white">Bespoke<br />Suiting</h1>
        <div className="w-10 h-px bg-primary mb-4" />
        <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed">Individually drafted garments built around your posture, proportions, and intent.</p>
      </div>
      {/* Desktop banner */}
      <header className="hidden lg:block relative w-full lg:h-[70vh] overflow-hidden bg-background-light dark:bg-background-dark">
        <div className="relative z-10 flex flex-col justify-center w-full lg:w-[45%] lg:h-full px-6 sm:px-8 md:px-16 lg:px-20 py-8 lg:py-0 flex-shrink-0">
          <span className="text-[10px] uppercase tracking-[0.5em] text-primary mb-6">Bespoke Craft</span>
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[0.95] mb-6 dark:text-white">Bespoke<br />Suiting</h1>
          <div className="w-10 h-px bg-primary mb-6" />
          <p className="text-gray-500 dark:text-gray-400 text-sm max-w-xs leading-relaxed">Individually drafted garments built around your posture, proportions, and intent.</p>
        </div>
        <div className="absolute inset-y-0 right-0 w-[65%] h-full">
          <img src="/images/mans-tailoring-banner.webp" alt="Bespoke Suiting" className="w-full h-full object-cover object-top" />
          <div className="absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-background-light dark:from-background-dark to-transparent" />
        </div>
      </header>

      <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center mb-14">
          <h2 className="font-display text-3xl md:text-4xl mb-6">Precision from First Consultation to Final Fitting</h2>
          <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
            Our bespoke process combines hand measurements, pattern drafting, and staged fittings to deliver
            a personal silhouette with long-term structure and comfort.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {offerings.map((item) => (
            <div key={item.title} className="rounded-2xl overflow-hidden shadow-md bg-white dark:bg-surface-dark group">
              <div className="relative w-full overflow-hidden" style={{paddingBottom: '133%', height: 0}}>
                <img src={item.img} alt={item.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="hidden md:block absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="hidden md:block absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="font-display text-xl text-white mb-1">{item.title}</h3>
                  <p className="text-white/70 text-xs leading-relaxed">{item.detail}</p>
                </div>
              </div>
              <div className="block md:hidden px-3 py-2">
                <h3 className="font-display text-sm leading-tight mb-1 dark:text-white">{item.title}</h3>
                <p className="text-gray-500 dark:text-gray-400 text-xs leading-relaxed">{item.detail}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default BespokeSuiting;
